import { toggleDisLikeAPI } from "./toggleDisLikeAPI";
import { toggleLikeAPI } from "./toggleLikeAPI";
import { getVideo } from "./videoAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
    video: {},
    isLoading: false,
    isError: false,
    error: "",
    liked: false,
    unLiked: false,
};

// async thunk
export const fetchVideo = createAsyncThunk("video/fetchVideo", async (id) => {
    const video = await getVideo(id);
    return video;
});

export const toggleLike = createAsyncThunk("video/toggleLike", async (id, thunkAPI) => {
    const { video: { liked, unLiked, video: { likes, unlikes } } } = thunkAPI.getState();
    return await toggleLikeAPI(id, liked ? likes - 1 : likes + 1, unLiked ? unlikes - 1 : unlikes);
})
export const toggleDisLike = createAsyncThunk("video/toggleDisLike", async (id, thunkAPI) => {
    const { video: { liked, unLiked, video: { likes, unlikes } } } = thunkAPI.getState();
    return await toggleDisLikeAPI(id, liked ? likes - 1 : likes, unLiked ? unlikes - 1 : unlikes + 1);
})

const videoSlice = createSlice({
    name: "video",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchVideo.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchVideo.fulfilled, (state, action) => {
                state.isLoading = false;
                state.video = action.payload;
                state.liked = false;
                state.unLiked = false;
            })
            .addCase(fetchVideo.rejected, (state, action) => {
                state.isLoading = false;
                state.video = {};
                state.isError = true;
                state.error = action.error?.message;
            })

            .addCase(toggleLike.fulfilled, (state, action) => {
                state.video.likes = action.payload.likes;
                state.video.unlikes = action.payload.unlikes;
                state.liked = !state.liked;
                state.unLiked = false;
            })
            .addCase(toggleDisLike.fulfilled, (state, action) => {
                state.video.likes = action.payload.likes;
                state.video.unlikes = action.payload.unlikes;
                state.liked = false;
                state.unLiked = !state.unLiked;
            })
    },
});

export default videoSlice.reducer;
